<ng-container *ngIf="component">

    <div class="video-component overflow-hidden"
         [ngClass]="[component.ratio || '']">

        <!-- image -->
        <ng-container *ngIf="component.backgroundImage">
            <shell></shell>
            <img class="z-1"
                 [fill]="true"
                 [ratio]="component.ratio"
                 [dfImage]="component.backgroundImage">
        </ng-container>

        <ng-container *ngIf="component.videoId">
            <youtube-player class="z-2"
                            [class.rf]="!!component.ratio"
                            [video-id]="component.videoId"
                            [autoplay-in-viewport]="component.videoAutoplay"
                            [background]="component.videoBackground"
                            *ngIf="component.videoProvider === 'youtube'">
                <!-- play icon -->
                <ng-template #playButton>
                    <i class="icon-play"></i>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <i class="icon-pause"></i>
                </ng-template>
            </youtube-player>

            <vimeo-player class="z-2"
                          [class.rf]="!!component.ratio"
                          [video-id]="component.videoId"
                          [autoplay-in-viewport]="component.videoAutoplay"
                          [background]="component.videoBackground"
                          *ngIf="component.videoProvider === 'vimeo'">
                <!-- play icon -->
                <ng-template #playButton>
                    <i class="icon-play"></i>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <i class="icon-pause"></i>
                </ng-template>
            </vimeo-player>
        </ng-container>
    </div>

</ng-container>
